import client from "./axiosConfig";

export const getPayroll = (params) => {
    const config = {
        url: "/payroll/salary-master/",
        method: "GET",
        params
    };
    const response = client(config);
    return response;
};

export const addPayroll = (data) => {
    const config = {
        url: "/payroll/salary-master/",
        method: "POST",
        data
    };
    const response = client(config);
    return response;
};

export const deletePayroll = (payrollId) => {
    const config = {
        url: `/payroll/salary-master/${payrollId}/`,
        method: "DELETE",
    }

    const response = client(config);
    return response;
}

export const getPayrollById = (payrollId) => {
    const config = {
        url: `/payroll/salary-master/${payrollId}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const updatePayroll = (id, data) => {
    const config = {
        url: `/payroll/salary-master/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const getSalarySlips = (params) => {
    const config = {
        url: "/payroll/salary-slip/",
        method: "GET",
        params
    };
    const response = client(config);
    return response;
};

export const getSalarySlipById = (slipId) => {
    const config = {
        url: `/payroll/salary-slip/${slipId}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const updateSalarySlips = (id, data) => {
    const config = {
        url: `/payroll/salary-slip/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const run_payroll = ({ month }) => {
    const config = {
        url: `/payroll/salary-slip/run-payroll/?month=${month}`,
        method: "POST",
    };
    const response = client(config);
    return response;
};

export const notifyDownloadSlips = (slip_id) => {
    const config = {
        url: `/payroll/salary-slip/${slip_id}/notify-download/`,    
        method: "POST",
    };
    const response = client(config);
    return response;
};